import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { MdDone } from "react-icons/md";
import useStyles from './ConfirmAccountConfirmationCardStyles';
import {
    Button,
    Container,
} from '@mui/material';
import useHistory from '@/hooks/useHistory';
import { connect } from "react-redux";

interface Props {
    settings: any,
}

const ConfirmAccountConfirmationCard: React.FC<Props> = props => {

    const { classes, cx } = useStyles();
    const history = useHistory();

    const {
        settings,
    } = props;

    const navigateHome = () => {
        let path = '/login';
        history.push(path);
    }

    return (
        <AuthPage
            title="Your account has been confirmed and is now active!"
            icon={<MdDone />}
            iconTone="ok"
            actions={<button type="button" className="pb-btn pb-btn-primary" onClick={navigateHome}>Go To Log In</button>}>
            <p>Please use the temporary password provided in the account confirmation email on your first log in. You will be required to change your password once you have logged in.</p>
            <p>Please click on the button below to log in.</p>
        </AuthPage>
    )

}


const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(ConfirmAccountConfirmationCard);